import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import { useIntl } from "react-intl";

import $ from "jquery";

import styles from "./SearchBar.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faTimes } from "@fortawesome/free-solid-svg-icons";
import * as SearchConstant from "../../Constants/SearchConstant";
import * as SearchUtils from "../../Utils/SearchUtils";
import * as CustomDataUtils from "../../../middleware/Utils/CustomDataUtils";
import CheckBox, { CheckBoxLabelSize } from "../../UI/Button/CheckboxButton";

import LogService from "../../../middleware/CommonSdk/LogService";

const SEARCH_SELECTOR = "searchBar_search_selector";
const SEARCH_SELECTOR_INPUT = SEARCH_SELECTOR + "_input";
const SEARCH_SELECTOR_DROPDOWN = SEARCH_SELECTOR + "_dropdown_collapse";

const LOG_TAG = "SEARCH_BAR";

const SearchBar = props => {
    const [searchedText, setSearchedText] = useState("");
    const [searchFilterList, setSearchFilterList] = useState([]);
    const [firstInitDone, setFirstInitDone] = useState(false);
    const [indexLoaded, setIndexLoaded] = useState(false);
    const [currentSearchUrl, setCurrentSearchUrl] = useState(SearchConstant.SEARCH_PATH);

    const intl = useIntl();

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect searchFilterList");
        if (firstInitDone) {
            if (searchedText?.length > 0) {
                const action = () => {
                    let newSearchUrl = currentSearchUrl;
                    newSearchUrl = SearchUtils.addOrUpdateQueryParameterToPathString(newSearchUrl, SearchConstant.SearchTagName, searchedText);

                    let allAvailablefilters = SearchUtils.getAllAvailableSearchFilters(props.indexFiles, props.documentationFilter);
                    allAvailablefilters.forEach(item => {
                        let value = searchFilterList.some(selectedFilter => selectedFilter === item ) ? true : null; //null removes key
                        newSearchUrl = SearchUtils.addOrUpdateQueryParameterToPathString(newSearchUrl, item, value);
                    });
                    LogService.info(LOG_TAG, "start search with:", newSearchUrl);
                    props.history.push(newSearchUrl);
                }
                SearchUtils.debounce(action, SearchConstant.SEARCH_START_TIME);
            }
        }
    }, [searchedText, searchFilterList]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location");
        if (SearchUtils.isSearchPath(props.location)) {//update when url is search path
            const searchValue = SearchUtils.getSearchValue(props.location);
            const searchFilter = SearchUtils.getSearchFilterList(props.location);
            if (SearchUtils.isSearchAvailable(props.indexFiles)) {//also back on former search
                LogService.debug(LOG_TAG, "useEffect location. searchText from url:", searchValue);
                setSearchedText(searchValue);
                if (!SearchUtils.hasSameContentList(searchFilterList, searchFilter)) {
                    setSearchFilterList(searchFilter);
                }
                setCurrentSearchUrl(props.location.pathname + props.location.search);
            } else {//clear search if reload or set url and no index available
                LogService.warn(LOG_TAG, "useEffect location. search not available");
                if (!indexLoaded) {//case set url and index not loaded yet
                    LogService.debug(LOG_TAG, "useEffect location. search not loaded yet. memorise search");
                    setSearchedText(searchValue);
                    if (!SearchUtils.hasSameContentList(searchFilterList, searchFilter)) {
                        setSearchFilterList(searchFilter);
                    }
                    setCurrentSearchUrl(props.location.pathname + props.location.search);
                } else {
                    clearSearchInput(true);
                }
            }
        } else if (searchedText.length > 0) {//clear search on click on other item in sidebar,...
            LogService.debug(LOG_TAG, "useEffect location. clear search");
            clearSearchInput(false);
        }
    }, [props.location]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect indexFiles customUserData");
        if (firstInitDone) {//case set url: to avoid trig searchFilterList useEffect
            setIndexLoaded(true);

            let selectedFilter = CustomDataUtils.getSearchIndexPreferences(props.customUserData);
            const locationFilter = SearchUtils.getSearchFilterList(props.location);
            if (locationFilter.length > 0) // keep memorized filter by set url
                selectedFilter = locationFilter;

            initializeSearchFilter(selectedFilter);
        }
    }, [props.indexFiles, props.customUserData, props.documentationFilter]);

    useEffect(() => {//click outside dropdown -> close list
        LogService.trace(LOG_TAG, "useEffect didmount");

        const element = document.getElementById(SEARCH_SELECTOR_INPUT);
        const listener = event => {
            const divElement = document.getElementById(SEARCH_SELECTOR);
            // Do nothing if clicking ref's element or descendent elements
            if (!divElement || divElement.contains(event.target)) {
                return;
            }
            closeDropdown();
            document.removeEventListener("mousedown", listener);
        };
        if (element) {
            element.addEventListener("focusin", () => {
                LogService.debug(LOG_TAG, "useEffect outside click add mousedown listener");
                document.addEventListener("mousedown", listener);
            });
        }

        //add jquery function : get textWidth in pixel
        $.fn.textWidth = function (text, font) {
            const inputElement = $("#" + SEARCH_SELECTOR);
            if (!$.fn.textWidth.fakeEl)
                $.fn.textWidth.fakeEl = $('<span id="fakeEl" class=' + styles.fakeElement + '>').appendTo(inputElement);
            var htmlText = text || this.val() || this.text();
            htmlText = $.fn.textWidth.fakeEl.text(htmlText).html(); //encode to Html
            htmlText = htmlText?.replace(/\s/g, "&nbsp;"); //replace trailing and leading spaces
            // $.fn.textWidth.fakeEl.html(htmlText).css('font', font || this.css('font'));
            $.fn.textWidth.fakeEl.html(htmlText).css({ "font-size": "0.9rem", "letter-spacing": 1.2 });//0.9 and 1.2 are style for input form-control style
            return $.fn.textWidth.fakeEl.width();
        };

        setFirstInitDone(true);
        return () => {
            LogService.trace(LOG_TAG, "useEffect outside click release");
            if (element) {
                element.removeEventListener("focusin", listener);
            }
        };
    }, []);

    const closeDropdown = () => {
        LogService.trace(LOG_TAG, "closeDropdown");
        $("#" + SEARCH_SELECTOR).find(".collapse").collapse("hide");
    }

    const showDropdown = () => {
        LogService.trace(LOG_TAG, "showDropdown");
        $("#" + SEARCH_SELECTOR).find(".collapse").collapse("show");
    }

    const searchTextInputChangedHandler = (event) => {
        LogService.trace(LOG_TAG, "new text:", event.target.value);
        const newSearchedText = event.target.value;

        if (newSearchedText.length === 0) {
            clearSearchInput(true);
        } else {
            setSearchedText(newSearchedText);
        }

        if (SearchUtils.filterSearchValue(newSearchedText).length > 0) {
            showDropdown();
        } else {
            closeDropdown();
        }
    }

    const clearSearchInput = (withHomePush) => {
        LogService.trace(LOG_TAG, "clearSearchInput");
        SearchUtils.clearDebounce();
        setSearchedText("");
        initializeSearchFilter(CustomDataUtils.getSearchIndexPreferences(props.customUserData));
        setCurrentSearchUrl(SearchConstant.SEARCH_PATH);
        closeDropdown();
        if (withHomePush) {
            props.history.push(SearchConstant.HOME_PATH);
        }
    }

    const initializeSearchFilter = (preSelectedFilter) => {
        LogService.trace(LOG_TAG, "initializeSearchFilter");

        let filters = SearchUtils.getAllAvailableSearchFilters(props.indexFiles, props.documentationFilter);
        LogService.debug(LOG_TAG, "initializeSearchFilter all filter", filters);

        if (preSelectedFilter?.length > 0) {
            filters = SearchUtils.filterSearchFilters(filters, preSelectedFilter);
        }

        setSearchFilterList(filters);
    }

    const handleSearchFilterItemToggle = (itemId) => {
        LogService.trace(LOG_TAG, "handleSearchFilterItemToggle:", itemId);
        const index = searchFilterList.indexOf(itemId);
        if (index < 0) {
            $("#" + itemId).addClass(styles.checked);
            setSearchFilterList([...searchFilterList, itemId]);
        } else {
            $("#" + itemId).removeClass(styles.checked);
            setSearchFilterList(searchFilterList.filter((item) => (item !== itemId)));
        }
    }

    const getPixelOffsetForText = (text) => {
        return $.fn.textWidth(text) || 0;
    }

    LogService.trace(LOG_TAG, "render");
    const sdkFilterItems = SearchUtils.getAvailableSdkFilterList(props.indexFiles, props.documentationFilter)
        .map((filterItem) => {
            let displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const apiFilterItems = SearchUtils.getAvailableApiFilterList(props.indexFiles, props.documentationFilter)
        .map((filterItem) => {
            let displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const otherFilterItems = SearchUtils.getAvailableOtherFilterList(props.indexFiles, props.documentationFilter)
        .map((filterItem) => {
            let displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            displayName = intl.messages[filterItem] ? intl.messages[filterItem] : displayName;
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const searchFilterItemlist = [];
    if (sdkFilterItems.length > 0) {
        searchFilterItemlist.push(
            // className="d-inline-block py-2 px-2" style={{width:"100px"}}
            <li key="0" className={styles.dropdownItem}>
                <div id={SearchConstant.SearchFilterSdkPrefix} className="w-100 text-center text-white bg-night" >{intl.messages.searchFilterSdk}</div>
                {sdkFilterItems}
            </li>
        );
    }
    if (apiFilterItems.length > 0) {
        searchFilterItemlist.push(
            <li key="1" className={styles.dropdownItem}>
                <div id={SearchConstant.SearchFilterApiPrefix} className="w-100 text-center text-white bg-night">{intl.messages.searchFilterApi}</div>
                {apiFilterItems}
            </li>
        )
    };
    if (otherFilterItems.length > 0) {
        searchFilterItemlist.push(
            <li key="2" className={styles.dropdownItem}>
                <div id={SearchConstant.SearchFilterOtherPrefix} className="w-100 text-center text-white bg-night">{intl.messages.searchFilterOther}</div>
                {otherFilterItems}
            </li>
        )
    };

    let ignoredWordsDisplay = null;
    const ignoredWords = SearchUtils.ignoredSearchValues(searchedText);
    if (ignoredWords.length > 0) {
        const toolTipMessage = intl.formatMessage({ id: "searchTextError" }, { value: SearchConstant.SearchMinLength });
        const ignoredWordsItems = ignoredWords.map((item, i) => {
            const startOffset = getPixelOffsetForText(searchedText.substr(0, item.start));
            const endOffset = getPixelOffsetForText(searchedText.substr(0, item.start + item.length));
            const backgroundCss = {
                left: 10 + startOffset,//10 is padding offset for input form-control style
                width: endOffset - startOffset
            }

            return <p key={i} style={backgroundCss} data-toggle="tooltip" data-placement="bottom" title={toolTipMessage} />
        });
        ignoredWordsDisplay = <div id="searchBar_ignoredWords" className={styles.ignoredWords} >{ignoredWordsItems}</div>
    }

    let display = null;
    if (SearchUtils.isSearchAvailable(props.indexFiles)) {
        let tooltipTemplate = '<div class="tooltip" role="tooltip">\
            <div class="arrow"></div>\
            <div class="tooltip-inner ' + styles["tooltip-inner"] + '"></div>\
        </div>';
        display =
            <div id={SEARCH_SELECTOR} className="dropdown" style={{ width: "300px" }}>
                {ignoredWordsDisplay}
                <div className="input-group flex-nowrap">
                    <input id={SEARCH_SELECTOR_INPUT}
                        type="text"
                        className="form-control w-100"
                        placeholder={intl.messages.searchBarPlaceHolder}
                        aria-label={intl.messages.searchBarLabel}
                        value={searchedText}
                        onChange={searchTextInputChangedHandler}
                        autoComplete="off"
                        data-toggle={searchedText ? "collapse" : ""}
                        data-target={"#" + SEARCH_SELECTOR_DROPDOWN}
                        spellCheck="false"
                    />

                    {searchedText &&
                        <div className="input-group-append">
                            <button className="btn input-btn" type="button" onClick={() => clearSearchInput(true)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                    }
                    {searchedText &&
                        <div className={"input-group-append"}
                            data-tooltip
                            title={intl.messages.searchTextSyntaxTip}
                            data-template={tooltipTemplate}
                        >
                            <span className="input-group-text">
                                <FontAwesomeIcon icon={faInfo} />
                            </span>
                        </div>
                    }
                </div>

                <ul id={SEARCH_SELECTOR_DROPDOWN} className="collapse dropdown-menu">
                    {searchFilterItemlist}
                </ul>
            </div>
    }

    return display;
};

SearchBar.defaultProps = {
}

SearchBar.propTypes = {
};

const mapStateToProps = state => {
    return {
        indexFiles: state.search.indexFiles,
        customUserData: state.user.customUserData,
        documentationFilter: state.documentation.filter
    };
};

export default withRouter(connect(mapStateToProps)(SearchBar));
